import Entity from "entity";

export default class Perfil extends Entity {
    static get collectionUID() {
        return "PerfilUser";
    }
    async initialize() { }

    static async onQuery(collection) {
        return collection;
    }

    static get labelField() {
        return "name";
    }

    static get searchColumns() {
        return [
            { field: "name", headerName: "Nome", flex: 2, filter: true },
            { field: "email", headerName: "E-Mail", flex: 2, filter: true },
            {
                field: "tipoPerfil",
                headerName: "Tipo de Perfil",
                flex: 2,
                filter: true,
                valueGetter: ({ value }) => {
                    try {
                        if (value === "admin") return "ADMINISTRADOR"
                        else return "COLABORADOR";
                    } catch { }
                }
            },
        ];
    }
}
